import { APP_INITIALIZER, importProvidersFrom, Injector, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LOCATION_INITIALIZED, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { JwtModule } from '@auth0/angular-jwt';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { AuthInterceptorService } from '@core/services/auth-interceptor.service';
import { FormGroupDirective } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { UserEffects } from './components/user-profile/store/user.effects';
import { StoreModule } from '@ngrx/store';
import * as fromApp from './features/store/app.reducer';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CanDeactivateGuard } from './core/helper/can-deactivate.guard';

export function tokenGetter() {
  return localStorage.getItem('access_token') as string;
}

registerLocaleData(localeDe);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    StoreModule.forRoot(fromApp.APP_REDUCER),
    StoreDevtoolsModule.instrument({ autoPause: true }),
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    ToastModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient): MultiTranslateHttpLoader => {
          return new MultiTranslateHttpLoader(http, [
            { prefix: './assets/i18n/login/', suffix: '.json' },
            { prefix: './assets/i18n/prime-ng/', suffix: '.json' },
            { prefix: './assets/i18n/copyright/', suffix: '.json' },
            { prefix: './assets/i18n/wrappers/', suffix: '.json' },
            { prefix: './assets/i18n/dashboard/', suffix: '.json' },
            { prefix: './assets/i18n/commons/', suffix: '.json' },
            { prefix: './assets/i18n/orders/', suffix: '.json' },
            { prefix: './assets/i18n/user-profile/', suffix: '.json' },
            { prefix: './assets/i18n/administration/', suffix: '.json' },
            { prefix: './assets/i18n/imprint/', suffix: '.json' }
          ]);
        },
        deps: [HttpClient]
      }
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      }
    }),
    EffectsModule.forRoot([
      UserEffects
    ])
  ],
  providers: [
    CanDeactivateGuard,
    FormGroupDirective,
    MessageService,
    importProvidersFrom(HttpClientModule),
    {
      provide: APP_INITIALIZER,
      useFactory: (translate: TranslateService, injector: Injector): object => {
        return async (): Promise<void> => {
          await injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
          translate.addLangs(['de']);
          translate.setDefaultLang('de');
          try {
            await translate.use(translate.defaultLang).toPromise();
          } catch (err) {
            // TODO: implement logger service @Istvan
          }
        };
      },
      deps: [TranslateService, Injector],
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'de' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}

